"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Click = exports.ClickConfiguration = exports.ClickFooter = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
const ElementReferenceFields_1 = require("../../editor/ElementReferenceFields");
const StepNavigation_1 = require("../StepNavigation");
function useOnClick(element, onClick) {
    react_2.default.useEffect(() => {
        const htmlElement = document.querySelector(element.selector);
        if (htmlElement) {
            htmlElement.addEventListener('click', onClick);
            return () => {
                htmlElement.removeEventListener('click', onClick);
            };
        }
    }, [element, onClick]);
}
function ClickFooter({ step, onUpdateStep }) {
    useOnClick(step.element, () => {
        onUpdateStep(1);
    });
    return (react_2.default.createElement(StepNavigation_1.StepNavigation, { onUpdateStep: onUpdateStep, message: react_2.default.createElement(react_1.Markdown, { children: step.actionMessage, inline: true }), disabled: true, noNext: true }));
}
exports.ClickFooter = ClickFooter;
function ClickConfiguration({ prefix }) {
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(ElementReferenceFields_1.ElementReferenceFields, { prefix: `${prefix}.element`, required: true }),
        react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.actionMessage`, label: 'Action Message', required: { value: true, message: 'An action message is required.' }, extra: 'Shown in the footer to give the user an exact instruction on what to do. Supports Markdown.' },
            react_2.default.createElement(react_1.Input, { placeholder: 'eg. Click the button.' }))));
}
exports.ClickConfiguration = ClickConfiguration;
exports.Click = {
    label: 'Click',
    renderConfiguration: ClickConfiguration,
    renderFooter: ClickFooter,
};
//# sourceMappingURL=Click.js.map